import {Button, Stack, styled} from '@mui/material';
import {StyledStackProps} from './types';

const StyledStack = styled(Stack)<StyledStackProps>`
	background-color: ${({theme}) => theme.palette.other.planColor || theme.palette.primary.main};
	padding-top: 16px;
	justify-content: center;
	align-items: center;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-top: 8px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		border-radius: 16px;
		padding-block: 32px;
	}
`;

const StyledButtonContainer = styled(Stack)`
	width: 100%;
	flex-direction: row;
	gap: 16px;
	padding-inline: 16px;
	padding-bottom: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-inline: 32px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		padding-bottom: 0px;
	}
`;

const StyledButton = styled(Button)`
	max-width: 328px;
	margin-inline: auto;
	width: 100%;
	color: white;
	border-color: white;
	margin-top: 16px;

	${({theme}) => theme.breakpoints.up('md')} {
		margin-top: 24px;
	}

	&:is(:hover, :disabled) {
		border-color: white;
		color: white;
	}
`;

export {StyledStack, StyledButtonContainer, StyledButton};
